import React from 'react';
import { Link } from 'react-router-dom';
import './Nav_links.css';

const Nav_links = (props) => {
    return (
        <li>
            <Link className="nav__link" to={props.to}>{props.text}</Link>
        </li>
    );
}

export default Nav_links;